import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { withStyles, TableBody, TableRow, TableCell, Table } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import { EVENT_IMG } from '../constatns';
// import Preparing from '../components/Preparing';

const styles = (theme) => ({
  table: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    '& tr:last-child': { borderBottom: `2px solid ${theme.palette.primary.main}` },
    '& th': {
      width: '30%',
      fontSize: 'large',
      fontWeight: 'bold',
      textAlign: 'left',
      color: theme.palette.primary.main,
      borderBottom: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: '#f8f9fa',
      paddingLeft: '20px',
      '& span': {
        color: 'red',
      },
    },
    '& td': {
      paddingLeft: '20px',
      color: '#555',
      fontWeight: 500,
    },
  },
  evtTitle: {
    '& p > b': {
      color: theme.palette.primary.main,
    },
  },
});

class Overview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { classes } = this.props;

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={0} SIdx={1} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Overview</MainTitle>

              {/* 2022 CUSTOM::  테이블 내용 수정 */}
              <Table>
                <TableBody className={classes.table}>
                  <TableRow>
                    <TableCell component={'th'} colSpan={1}>
                      Title
                    </TableCell>
                    <TableCell colSpan={3} className={classes.evtTitle}>
                      <p>
                        <b style={{ fontSize: 'large' }}>PRS KOREA 2022</b>
                      </p>
                      <p style={{ color: '#555', fontWeight: 500 }}>
                        The 80<sup>th</sup> Congress of Korean Society of <b>P</b>lastic and <b>R</b>econstructive <b>S</b>urgeons
                      </p>
                      <p style={{ color: '#555', fontWeight: 500 }}>
                        The 25<sup>th</sup> Scientific Meeting of Korean Cleft Palate-Craniofacial Association
                      </p>
                      <p style={{ color: '#555', fontWeight: 500 }}>
                        Seoul Rhinoplasty Forum 2022 <sup style={{ color: 'transparent' }}>aa</sup>
                      </p>
                      <p style={{ color: '#555', fontWeight: 500 }}>
                        Seoul Breast Meeting 2022 <sup style={{ color: 'transparent' }}>aa</sup>
                      </p>
                      <p style={{ color: '#555', fontWeight: 500 }}>
                        The 5<sup>th</sup> Asian Forum for Fat and Stem Cells
                      </p>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'} colSpan={1}>
                      Date
                    </TableCell>
                    <TableCell colSpan={3}>
                      <b style={{ color: '#555' }}>November 11 (Fri) – 13 (Sun), 2022</b>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>Venue</TableCell>
                    <TableCell>Grand Intercontinental Seoul Parnas, Seoul, Korea (In Person Event)</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>Theme</TableCell>
                    <TableCell>Humanity, Beyond Technology</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>Host</TableCell>
                    <TableCell>
                      <Grid container alignItems="center">
                        <img src={`${EVENT_IMG}/ic/ic_overview_kprs.png`} alt="ksprs_logo" />
                        &nbsp; Korean Society of Plastic and Reconstructive Surgeons
                      </Grid>
                      <Grid container alignItems="center">
                        <img src={`${EVENT_IMG}/ic/ic_overview_kcpca.png`} alt="kcpca_logo" />
                        &nbsp; Korean Cleft Palate-Craniofacial Association
                      </Grid>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>Official Language </TableCell>
                    <TableCell>English</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>Website</TableCell>
                    <TableCell>https://www.prskorea.org</TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell component={'th'}>Welcome Reception</TableCell>
                    <TableCell>November 11(Fri), 2022</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>KSPRS General Assembly</TableCell>
                    <TableCell>November 13(Sat), 2022</TableCell>
                  </TableRow> */}
                  <TableRow>
                    <TableCell component={'th'}>PRS KOREA 2022 Secretariat</TableCell>
                    <TableCell>
                      8th FL, The Liv Sejong Tower, 126 Achasan-ro, Seongdong-gu, Seoul, 04783, Korea
                      <br />
                      <p style={{ color: '#555', fontWeight: 500 }}>
                        <b>
                          General
                          <b style={{ color: 'transparent' }}>aa</b>
                        </b>
                        E.&nbsp;
                        <a href={'mailto:secretariat.kprs@innon.co.kr'}>secretariat.kprs@innon.co.kr</a> | T. +82-2-6411-7380
                      </p>
                      <p style={{ color: '#555', fontWeight: 500 }}>
                        <b>Academic</b> E.&nbsp;
                        <a href={'mailto:academic.kprs@innon.co.kr'}>academic.kprs@innon.co.kr</a> | T. +82-2-6411-7319, 7378
                      </p>
                      {/* <br /> Tel. +82-2-6411-7378,7313,7321
                      <br /> Fax. +82-2-6411-7399
                      <br /> E-mail : secretariat.kprs@innon.co.kr */}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Overview);
